import * as RemoteData from '../utils/remoteData';

const SET_LOCAL_STORAGE = 'SET_LOCAL_STORAGE';
export const setLocalStorage = (payload) => ({
  type: SET_LOCAL_STORAGE,
  payload,
});

export const SET_TENANT_SLUG = 'SET_TENANT_SLUG';
export const setTenantSlug = (tenantSlug) => ({
  type: SET_TENANT_SLUG,
  payload: { tenantSlug },
});

export const FETCH_TENANT_CONFIGURATION = 'FETCH_TENANT_CONFIGURATION';
export const fetchTenantConfiguration = () => ({
  type: FETCH_TENANT_CONFIGURATION,
});

export const FETCH_TENANT_CONFIGURATION_SUCCESS =
  'FETCH_TENANT_CONFIGURATION_SUCCESS';
export const fetchTenantConfigurationSuccess = (data) => ({
  type: FETCH_TENANT_CONFIGURATION_SUCCESS,
  payload: { data },
});

export const FETCH_TENANT_CONFIGURATION_ERROR =
  'FETCH_TENANT_CONFIGURATION_ERROR';
export const fetchTenantConfigurationError = (error) => ({
  type: FETCH_TENANT_CONFIGURATION_ERROR,
  payload: { error },
});

export const LOGOUT = 'LOGOUT';
export const logout = (data) => ({
  type: LOGOUT,
  payload: data,
});

export const ACCESS_TOKEN_EXPIRED = 'ACCESS_TOKEN_EXPIRED';
export const accessTokenExpired = () => ({ type: ACCESS_TOKEN_EXPIRED });

export const DELETE_ACCESS_TOKEN = 'DELETE_ACCESS_TOKEN';
export const deleteAccessToken = () => ({ type: DELETE_ACCESS_TOKEN });

const FETCH_THEME = 'FETCH_THEME';
export const fetchTheme = () => ({
  type: FETCH_THEME,
});

const FETCH_THEME_SUCCESS = 'FETCH_THEME_SUCCESS';
export const fetchThemeSuccess = (payload) => ({
  type: FETCH_THEME_SUCCESS,
  payload,
});

const FETCH_THEME_ERROR = 'FETCH_THEME_ERROR';
export const fetchThemeError = (error) => ({
  type: FETCH_THEME_ERROR,
  payload: { error },
});

export const FETCH_WORKFLOW = 'FETCH_WORKFLOW';
export const fetchWorkflow = (payload) => ({
  type: FETCH_WORKFLOW,
  payload,
});

const FETCH_WORKFLOW_SUCCESS = 'FETCH_WORKFLOW_SUCCESS';
export const fetchWorkflowSuccess = (payload) => ({
  type: FETCH_WORKFLOW_SUCCESS,
  payload,
});

const FETCH_WORKFLOW_ERROR = 'FETCH_WORKFLOW_ERROR';
export const fetchWorkflowError = (error) => ({
  type: FETCH_WORKFLOW_ERROR,
  payload: { error },
});

export const CLEAR_STATE = 'CLEAR_STATE';
export const clearState = () => ({
  type: CLEAR_STATE,
});

const initialState = {
  tenantSlug: null,
  theme: RemoteData.notAsked(),
  clientMetadata: RemoteData.notAsked(),
  routesConfig: RemoteData.notAsked(),
  landingPage: RemoteData.notAsked(),
  localStorage: {},
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_LOCAL_STORAGE:
      return {
        ...state,
        localStorage: { ...state.localStorage, ...payload },
      };

    case SET_TENANT_SLUG:
      return { ...state, tenantSlug: payload.tenantSlug };

    case FETCH_TENANT_CONFIGURATION:
      return {
        ...state,
        clientMetadata: RemoteData.loading(),
        settings: RemoteData.loading(),
        subClientPath: RemoteData.loading(),
        subClientSlug: RemoteData.loading(),
        payment: RemoteData.loading(),
      };

    case FETCH_TENANT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        clientMetadata: RemoteData.success(payload.data.meta),
        settings: RemoteData.success(payload.data.settings),
        subClientPath: RemoteData.success(payload.data.subClientPath),
        subClientSlug: RemoteData.success(payload.data.subClientSlug),
        payment: RemoteData.success(payload.data.payment),
      };

    case FETCH_TENANT_CONFIGURATION_ERROR:
      return {
        ...state,
        clientMetadata: RemoteData.error(payload.error),
        settings: RemoteData.error(payload.error),
        subClientPath: RemoteData.error(payload.error),
        subClientSlug: RemoteData.error(payload.error),
        payment: RemoteData.error(payload.error),
      };

    case FETCH_THEME:
      return { ...state, theme: RemoteData.loading() };

    case FETCH_THEME_SUCCESS:
      return { ...state, theme: RemoteData.success(payload) };

    case FETCH_THEME_ERROR:
      return { ...state, theme: RemoteData.error(payload.error) };

    case FETCH_WORKFLOW:
      return { ...state, workflows: RemoteData.loading() };

    case FETCH_WORKFLOW_SUCCESS:
      return { ...state, workflows: RemoteData.success(payload) };

    case FETCH_WORKFLOW_ERROR:
      return { ...state, workflows: RemoteData.error(payload.error) };

    default:
      return state;
  }
};

export default reducer;
